export class Effect {
    constructor(id, factor, parent_id, type) {
        this.id = id;
        this.factor = factor;
        this.parent_id = parent_id;
        this.type = type;
    }
}